import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import classNames from 'classnames'

export default function ShiftExchangeSiblingShift ({
  namePrefix = null,
  oldShift = false,
  newShift = false,
  userNamePrefix = 'user',
  shiftNamePrefix = null,
  className
}) {
  const _className = classNames(
    { 'bg-error': oldShift },
    { 'bg-available': newShift },
    'py-2 px-2',
    className
  )

  const textColor = (newShift || oldShift) ? 'lightgray' : 'gray'

  return (
    <UI.EmployeeInfo
      className={_className}
      width=''
      large
      avatar={<Displays.Image name={`${userNamePrefix}.avatar_url`} />}
      title={(
        <UI.Text block color={textColor}>
          <Displays.Text name={`${userNamePrefix}.name`} />
        </UI.Text>
      )}
      text={(
        <div>
          <div className='flex flex-col space-y-1'>
            <UI.Text block color={textColor}>
              <Displays.Text name={`${userNamePrefix}.employment_name`} />
            </UI.Text>
            <UI.Text block color={textColor}>
              <Displays.Time name={shiftNamePrefix ? shiftNamePrefix + '.start_at' : 'start_at'} forceUTC /> - <Displays.Time name={shiftNamePrefix ? shiftNamePrefix + '.end_at' : 'end_at'} forceUTC />
            </UI.Text>
          </div>
        </div>
      )}
      badges={<Displays.Badges name='user.display_badges' big />}
    />
  )
}
